import {WidgetFullEditorPortal} from "../common/WidgetFullEditorPortal"
import {TableWidgetData} from "@dv5/domain"
import {FC} from "react"
import {useWidgetEditState} from "../../hooks/useWidgetEditState"
import {useWidgetEditor} from "../../hooks/useWidgetEditor"
import {EditorWidgetProps} from "../../model/WidgetProps"
import {widgetService} from "../../services/widgetService"
import {WidgetFrame} from "../common/WidgetFrame"
import {TableViewer} from "./TableViewer"
import {TableWidgetFullEditor} from "./TableWidgetFullEditor"
import {TableWidgetToolbar} from "./TableWidgetToolbar"
import './TableWidget.less'

type Props = EditorWidgetProps

export const TableWidget: FC<Props> = ({
                                           canvasId,
                                           widget,
                                           selected,
                                           settings,
                                           editingWidgetId,
                                           onStartDrag,
                                           onStartResize,
                                           onContextMenu,
                                           dragState,
                                           onStartLinkCreation,
                                           onCompleteLinkCreation,
                                           onNavigate,
                                           onDeleteDataLink,
                                           onStopEditing,
                                       }) => {
    const data = widget.data as TableWidgetData
    const {isFullEditor, setIsFullEditor, stopEditing} = useWidgetEditState(onStopEditing, settings.readOnly)

    const {
        containerRef,
        resizeCursor,
        handlers,
        renderResizeHandles,
        renderLinkDots,
    } = useWidgetEditor({
        widget,
        selected,
        editingWidgetId,
        dragState,
        onStartDrag,
        onStartResize,
        onContextMenu,
        onStartLinkCreation,
        onCompleteLinkCreation,
        onNavigate,
        onDeleteDataLink,
    })

    if (editingWidgetId && editingWidgetId === widget.id) {
        const toolbarStyles = widgetService.getToolbarStyle(widget)
        return (
            <div className='table-widget-edit-container' ref={containerRef} onContextMenu={handlers.onContextMenu}>
                {!isFullEditor && (
                    <TableWidgetToolbar
                        canvasId={canvasId}
                        widgetId={widget.id}
                        data={data}
                        toolbarStyles={toolbarStyles}
                        onExpandToFull={() => setIsFullEditor(true)}
                    />
                )}
                <div
                    className={widgetService.getWidgetClasses(widget, 'tableWidget', selected, editingWidgetId, widget.commentsCount > 0)}
                    style={widgetService.getWidgetStyle(widget)}
                >
                    <TableViewer
                        sourceCode={data.text}
                        theme={data.theme}
                    />
                </div>
                {isFullEditor && (
                    <WidgetFullEditorPortal>
                        <TableWidgetFullEditor
                            canvasId={canvasId}
                            widgetId={widget.id}
                            data={data}
                            toolbarStyles={toolbarStyles}
                            onClose={stopEditing}
                        />
                    </WidgetFullEditorPortal>
                )}
            </div>
        )
    }

    return (
        <WidgetFrame
            baseClass='tableWidget'
            canvasId={canvasId}
            widget={widget}
            settings={settings}
            selected={selected}
            editingWidgetId={editingWidgetId}
            resizeCursor={resizeCursor}
            handlers={handlers}
            containerRef={containerRef}
            renderResizeHandles={renderResizeHandles}
            renderLinkDots={renderLinkDots}
            onNavigate={onNavigate}
            onDeleteDataLink={onDeleteDataLink}
        >
            <TableViewer
                sourceCode={data.text}
                theme={data.theme}
            />
        </WidgetFrame>
    )
}
